import { EmptyContentModel } from '../interfaces/empty-content.interface';

export const emptyContentAssets: EmptyContentModel = {
  title: 'No current assets found',
  subtitle: 'After your add first asset, you will be able to view it here.'
};

export const emptyContentClients: EmptyContentModel = {
  title: 'No clients yet.',
  subtitle: 'After you add your first client you will be able to view it here.'
};

export const emptyContentInvoice: EmptyContentModel = {
  title: 'No invoices yet.',
  subtitle: 'After you add your first invoice you will be able to view it here.'
};

export const emptyContentCurrentInvoice: EmptyContentModel = {
  title: 'No current invoices found',
  subtitle: 'After your first invoice, you will be able to view it here.'
};

export const emptyContentJob: EmptyContentModel = {
  title: 'No jobs yet.',
  subtitle: 'After you add your first job you will be able to view it here.'
};

export const emptyContentPriceBook: EmptyContentModel = {
  title: 'No price books yet.',
  subtitle: 'After you add your first price book you will be able to view it here.',
  buttonTitle: ['Create new Price Book']
};

export const emptyContentTransaction: EmptyContentModel = {
  title: 'No transactions yet.',
  subtitle: 'After your first transaction you will be able to view it here.'
};

export const emptyContentCharges: EmptyContentModel = {
  title: 'No charges yet.',
  subtitle: 'After you add your first charge you will be able to view it here.',
  buttonTitle: ['Create new Charge']
};

export const hiddenRowCharges: EmptyContentModel = {
  title: 'There are only invoiced Charges.',
  subtitle: 'You can view them by clicking on the button below.',
  buttonTitle: ['Create new Charge', 'View invoiced items']
};

export const emptyContentLedgerItem: EmptyContentModel = {
  title: 'No ledger items yet.',
  subtitle: 'After you add your first ledger item you will be able to view it here.',
  buttonTitle: ['Create new Ledger Item']
};


export const emptyContentLedgers: EmptyContentModel = {
  title: 'No ledger items yet.',
  subtitle: 'After you apply ledgers searcher you will be able to view your ledgers items here.',
};

export const emptyContentLedgersTab: EmptyContentModel = {
  title: 'Ledgers were not found',
  subtitle: 'Please, enter another search parameters',
};

export const emptyContentBankFeed: EmptyContentModel = {
  title: 'Bank Feeds is empty',
  subtitle: 'Please, import new bank feed',
};
